import zxcvbn from 'zxcvbn';
export class PasswordAnalyzer {
    /**
     * Evaluates the strength of a single password.
     */
    static checkStrength(password) {
        if (!password)
            return { score: 0, weak: true, suggestions: [] };
        const result = zxcvbn(password);
        return {
            score: result.score,
            weak: result.score < 2,
            suggestions: result.feedback.suggestions || [],
        };
    }
    /**
     * Analyzes an array of decrypted vault items to compute health metrics.
     * Modifies the array in-place or returns a mapped array with `health` property.
     * Assumes items have `plaintext.password` and `updated_at`.
     */
    static analyzeVaultHealth(items) {
        const passwordCounts = new Map();
        // First pass: count occurrences of each password to detect reuse
        for (const item of items) {
            const pwd = item.plaintext?.password;
            if (pwd) {
                passwordCounts.set(pwd, (passwordCounts.get(pwd) || 0) + 1);
            }
        }
        const ninetyDaysAgo = new Date();
        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);
        return items.map((item) => {
            const pwd = item.plaintext?.password;
            let health = null;
            if (pwd) {
                const strength = this.checkStrength(pwd);
                const updatedAt = new Date(item.updated_at || Date.now());
                health = {
                    score: strength.score,
                    weak: strength.weak,
                    suggestions: strength.suggestions,
                    reused: (passwordCounts.get(pwd) || 0) > 1,
                    old: updatedAt < ninetyDaysAgo,
                };
            }
            return {
                ...item,
                health,
            };
        });
    }
}
